import { api } from './apiClient'

export const FundsApi = {
  /**
   * Query funds with OData params.
   * @param {Object} params - { $top, $skip, $filter, $orderby, $count }
   * @returns {Promise<{ value: Array, '@odata.count'?: number }>}
   */
  getFunds(params = {}) {
    return api.get('/api/funds', params)
  },

  /**
   * Get a single fund by ID.
   */
  getFund(fundId) {
    return api.get(`/api/funds/${fundId}`)
  },

  /**
   * Create a new fund.
   * @param {{ name: string, displayOrder?: number }} data
   */
  createFund(data) {
    return api.post('/api/funds', data)
  },

  /**
   * Update a fund.
   * @param {string} fundId
   * @param {{ name?: string, displayOrder?: number }} data
   */
  updateFund(fundId, data) {
    return api.put(`/api/funds/${fundId}`, data)
  },

  /**
   * Soft-delete a fund.
   */
  deleteFund(fundId) {
    return api.delete(`/api/funds/${fundId}`)
  }
}
